import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  Col,
  Row,
  Progress,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";
import ApexActivityChart from "./components/ActivityChart.js";

import meal1 from "../../assets/dashboard/meal-1.svg";
import meal2 from "../../assets/dashboard/meal-2.svg";
import meal3 from "../../assets/dashboard/meal-3.svg";
import heartRed from "../../assets/dashboard/heartRed.svg";
import heartTeal from "../../assets/dashboard/heartTeal.svg";
import heartViolet from "../../assets/dashboard/heartViolet.svg";
import heartYellow from "../../assets/dashboard/heartYellow.svg";
import gymIcon from "../../assets/dashboard/gymIcon.svg";
import therapyIcon from "../../assets/dashboard/therapyIcon.svg";
import user from "../../assets/user.svg";
import statsPie from "../../assets/dashboard/statsPie.svg";

import s from "./Dashboard.module.scss";

const Dashboard = () => {
  const [checkboxes, setCheckboxes] = useState([true, false])

  const toggleCheckbox = (id) => {
    setCheckboxes(checkboxes => checkboxes
      .map((checkbox, index) => index === id ? !checkbox : checkbox ))
  }


  return (
    <div>
      <Row>
        <Col className="pr-grid-col" xs={12} lg={8}>
          <Row className="gutter mb-4">
            <Col className="mb-4 mb-md-0" xs={12} md={6}>
              <Widget className="widget-p-md">
                <div className="d-flex justify-content-between">
                  <div className="headline-3 d-flex align-items-center">Order Approvals</div>
                  <UncontrolledDropdown>
                    <DropdownToggle caret>
                      &nbsp; Pending &nbsp;
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Pending</DropdownItem>
                      <DropdownItem>Approved</DropdownItem>
                      <DropdownItem>All Orders</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                <div className={`mt-4 ${s.widgetBlock}`}>
                  <div className={s.widgetBody}>
                    <div className="d-flex">
                      <img className="img-fluid mr-2" src={meal1} alt="..." />
                      <div className="d-flex flex-column">
                        <p className="body-2">Bath Towels - White</p>
                        <p className="body-3 muted">Qty: 50 • $245.00</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <Button size="sm" color="success" className="mr-2">Approve</Button>
                      <Button size="sm" outline color="secondary">Reject</Button>
                    </div>
                  </div>
                </div>
                <div className={`mt-3 ${s.widgetBlock}`}>
                  <div className={s.widgetBody}>
                    <div className="d-flex">
                      <img className="img-fluid mr-2" src={meal2} alt="..." />
                      <div className="d-flex flex-column">
                        <p className="body-2">Shampoo Bottles</p>
                        <p className="body-3 muted">Qty: 24 • $156.00</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <Button size="sm" color="success" className="mr-2">Approve</Button>
                      <Button size="sm" outline color="secondary">Reject</Button>
                    </div>
                  </div>
                </div>
                <div className={`mt-3 ${s.widgetBlock}`}>
                  <div className={s.widgetBody}>
                    <div className="d-flex">
                      <img className="img-fluid mr-2" src={meal3} alt="..." />
                      <div className="d-flex flex-column">
                        <p className="body-2">Bed Sheet Sets - King</p>
                        <p className="body-3 muted">Qty: 15 • $420.00</p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <Button size="sm" color="success" className="mr-2">Approve</Button>
                      <Button size="sm" outline color="secondary">Reject</Button>
                    </div>
                  </div>
                </div>
              </Widget>
            </Col>
            <Col xs={12} md={6}>
              <Widget className="widget-p-md">
                <div className="d-flex justify-content-between">
                  <div className="headline-3 d-flex align-items-center">Low Stock Alerts</div>
                  <UncontrolledDropdown>
                    <DropdownToggle caret>
                      &nbsp; Critical &nbsp;
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>Critical</DropdownItem>
                      <DropdownItem>Low</DropdownItem>
                      <DropdownItem>All</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                <div className={`mt-4 ${s.widgetBlock}`}>
                  <div className={s.widgetBody}>
                    <div className="d-flex">
                      <img className="img-fluid mr-2" src={meal1} alt="..." />
                      <div className="d-flex flex-column">
                        <p className="body-2">Bath Towels</p>
                        <p className="body-3 muted">Room 201-220</p>
                      </div>
                    </div>
                    <div className="body-3 muted">
                      5 left
                    </div>
                  </div>
                </div>
                <div className={`mt-4 ${s.widgetBlock}`}>
                  <div className={s.widgetBody}>
                    <div className="d-flex">
                      <img className="img-fluid mr-2" src={meal2} alt="..." />
                      <div className="d-flex flex-column">
                        <p className="body-2">Shampoo Bottles</p>
                        <p className="body-3 muted">All Bathrooms</p>
                      </div>
                    </div>
                    <div className="body-3 muted">
                      12 left
                    </div>
                  </div>
                </div>
                <div className={`mt-4 ${s.widgetBlock}`}>
                  <div className={s.widgetBody}>
                    <div className="d-flex">
                      <img className="img-fluid mr-2" src={meal3} alt="..." />
                      <div className="d-flex flex-column">
                        <p className="body-2">Bed Sheets</p>
                        <p className="body-3 muted">King Size</p>
                      </div>
                    </div>
                    <div className="body-3 muted">
                      8 left
                    </div>
                  </div>
                </div>
              </Widget>
            </Col>
          </Row>
          <Row className="gutter">
            <Col className="mb-4 mb-xl-0" xs={6} sm={6} xl={3}>
              <Widget className="widget-p-sm">
                <div className={s.smallWidget}>
                  <div className="d-flex mb-4">
                    <img className="py-1 mr-2 img-fluid" src={heartRed} alt="..." />
                    <div className="d-flex flex-column">
                      <p className="headline-3">Towels</p>
                      <p className="body-2">45<span className="body-3 muted">/ 60</span></p>
                    </div>
                  </div>
                  <div>
                    <Progress color="secondary-red" className={`progress-xs ${s.mutedPink}`} value="75" />
                  </div>
                </div>
              </Widget>
            </Col>
            <Col className="mb-4 mb-xl-0" xs={6} sm={6} xl={3}>
              <Widget className="widget-p-sm">
                <div className={s.smallWidget}>
                  <div className="d-flex mb-4">
                    <img className="py-1 mr-2 img-fluid" src={heartYellow} alt="..." />
                    <div className="d-flex flex-column">
                      <p className="headline-3">Linens</p>
                      <p className="body-2">28<span className="body-3 muted">/ 40</span></p>
                    </div>
                  </div>
                  <div>
                    <Progress color="secondary-yellow" className={`progress-xs ${s.mutedYellow}`} value="70" />
                  </div>
                </div>
              </Widget>
            </Col>
            <Col xs={6} sm={6} xl={3}>
              <Widget className="widget-p-sm">
                <div className={s.smallWidget}>
                  <div className="d-flex mb-4">
                    <img className="py-1 mr-2 img-fluid" src={heartTeal} alt="..." />
                    <div className="d-flex flex-column">
                      <p className="headline-3">Toiletries</p>
                      <p className="body-2">92<span className="body-3 muted">/ 120</span></p>
                    </div>
                  </div>
                  <div>
                    <Progress color="secondary-cyan" className={`progress-xs ${s.mutedTeal}`} value="77" />
                  </div>
                </div>
              </Widget>
            </Col>
            <Col xs={6} sm={6} xl={3}>
              <Widget className="widget-p-sm">
                <div className={s.smallWidget}>
                  <div className="d-flex mb-4">
                    <img className="py-1 mr-2 img-fluid" src={heartViolet} alt="..." />
                    <div className="d-flex flex-column">
                      <p className="headline-3">Supplies</p>
                      <p className="body-2">156<span className="body-3 muted">/ 200</span></p>
                    </div>
                  </div>
                  <div>
                    <Progress color="violet" className={`progress-xs ${s.mutedViolet}`} value="78" />
                  </div>
                </div>
              </Widget>
            </Col>
          </Row>
        </Col>
        <Col className="mt-4 mt-lg-0 pl-grid-col" xs={12} lg={4}>
          <Widget className="widget-p-lg">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <p className="headline-3">Hotel Overview</p>
              <span className="badge badge-success">Active</span>
            </div>
            
            <div className={s.userParams}>
              <div className="d-flex flex-column">
                <p className="headline-3">124</p>
                <p className="body-3 muted">Total Rooms</p>
              </div>
              <div className="d-flex flex-column">
                <p className="headline-3">98</p>
                <p className="body-3 muted">Occupied</p>
              </div>
              <div className="d-flex flex-column">
                <p className="headline-3">26</p>
                <p className="body-3 muted">Available</p>
              </div>
            </div>
            
            <div className={s.goals}>
              <div className={s.goalsTitle}>
                <p className="headline-3">Inventory Status</p>
                <UncontrolledDropdown>
                  <DropdownToggle caret>
                    &nbsp; Today &nbsp;
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem>Today</DropdownItem>
                    <DropdownItem>This Week</DropdownItem>
                    <DropdownItem>This Month</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
              <div className="d-flex flex-column mt-3">
                <div className={s.activity}>
                  <p className="body-2">Critical Stock</p>
                  <p className="body-2">3<span className="body-3 muted"> items</span></p>
                </div>
                <Progress color="secondary-red" className="progress-xs" value={25} />
              </div>
              <div className="d-flex flex-column mt-3">
                <div className={s.activity}>
                  <p className="body-2">Low Stock</p>
                  <p className="body-2">12<span className="body-3 muted"> items</span></p>
                </div>
                <Progress color="secondary-yellow" className="progress-xs" value={60} />
              </div>
              <div className="d-flex flex-column mt-3">
                <div className={s.activity}>
                  <p className="body-2">Well Stocked</p>
                  <p className="body-2">85<span className="body-3 muted"> items</span></p>
                </div>
                <Progress color="secondary-cyan" className="progress-xs" value={90} />
              </div>
            </div>
            
            <p className="headline-3">Quick Actions</p>
            <div className={`mt-3 ${s.widgetBlock}`}>
              <div className={s.widgetBody}>
                <div className="d-flex">
                  <img className="img-fluid mr-2" src={gymIcon} alt="..." />
                  <div className="d-flex flex-column">
                    <p className="body-2">Add New Item</p>
                    <p className="body-3 muted">Add inventory items</p>
                  </div>
                </div>
                <Button size="sm" color="primary" outline>Add</Button>
              </div>
            </div>
            <div className={`mt-3 ${s.widgetBlock}`}>
              <div className={s.widgetBody}>
                <div className="d-flex">
                  <img className="img-fluid mr-2" src={therapyIcon} alt="..." />
                  <div className="d-flex flex-column">
                    <p className="body-2">Generate Report</p>
                    <p className="body-3 muted">Monthly inventory report</p>
                  </div>
                </div>
                <Button size="sm" color="primary" outline>Generate</Button>
              </div>
            </div>
            
            <a className={`btn-secondary-red ${s.statsBtn}`} href="#top" role="button">
              <img className={s.pieImg} src={statsPie} alt="..." />
              <div>
                <p className="headline-2">ANALYTICS</p>
                <p className="body-3">View detailed reports</p>
              </div>
            </a>
          </Widget>
        </Col>
      </Row>
    </div>
  )
}

export default Dashboard;
